__turbopack_context__.v({
  "button": "JyhrsW_button",
  "card": "JyhrsW_card",
  "image": "JyhrsW_image",
  "overline": "JyhrsW_overline",
  "productGroup": "JyhrsW_productGroup",
  "text": "JyhrsW_text",
  "withDelivery": "JyhrsW_withDelivery",
  "withProducts": "JyhrsW_withProducts",
  "withProgress": "JyhrsW_withProgress",
  "withTracking": "JyhrsW_withTracking",
});
